import { userPreferencesQuery } from '@pm2/api';
import { getAllCoursesQuery } from '@pm2/course-builder';
import { verticalPaddingCls } from '@pm2/react-utils';
import { MissingAccessMessage, NotFound, BasicFooter } from '@pm2/ui-components';
import { prefetchQueryIfNeeded } from '@utils/common';
import { wrapper, content, footer } from './_render-page.style.js';
import { getPortalsForUserQuery } from './features/portals/api.get-for-user.js';
import { FontPane } from './features/settings/molecule.font/_page.js';
import { MyTeamsPane } from './features/settings/molecule.my-teams/_page.js';
import { getTeamsQuery } from './features/settings/molecule.my-teams/api.get-teams.query.js';
import { SpeechSynthesisPane } from './features/settings/molecule.speech-synthesis/_page.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { getStatusForProductQuery } from './features/status/api.get-status.js';
import { Status } from './features/status/components/page.js';
import { CourseBuilderPage } from './features/courses/page.js';
import { Portals } from './features/portals/components/page.js';
import { EntriesPage } from './features/component-entries/page.js';
import { getNotificationsQuery } from './features/notifications/api.get-notifications.query.js';

async function renderUserAreaPage(descriptor, queryClient, user, productId) {
  if (descriptor.type !== "UserArea") {
    throw new Error("renderUserAreaPage(): Unable to render page based on descriptor as type does not match!");
  }
  if (!user) {
    return /*#__PURE__*/jsx("div", {
      className: verticalPaddingCls,
      children: /*#__PURE__*/jsx(MissingAccessMessage, {})
    });
  }
  const content$1 = await (async () => {
    switch (descriptor.id) {
      case "user-area.besvarelser":
        return /*#__PURE__*/jsx(EntriesPage, {});
      case "user-area.fagportaler":
        await prefetchQueryIfNeeded(queryClient, getPortalsForUserQuery(user));
        return /*#__PURE__*/jsx(Portals, {});
      case "user-area.forloeb":
        await Promise.all([prefetchQueryIfNeeded(queryClient, getAllCoursesQuery(user)), prefetchQueryIfNeeded(queryClient, getNotificationsQuery(user))]);
        return /*#__PURE__*/jsx(CourseBuilderPage, {});
      case "user-area.hold":
        await prefetchQueryIfNeeded(queryClient, getTeamsQuery(user));
        return /*#__PURE__*/jsx(MyTeamsPane, {});
      case "user-area.oplaesning":
        await prefetchQueryIfNeeded(queryClient, userPreferencesQuery.queryConfig({
          userId: user.id
        }));
        return /*#__PURE__*/jsx(SpeechSynthesisPane, {});
      case "user-area.skrifttype":
        await prefetchQueryIfNeeded(queryClient, userPreferencesQuery.queryConfig({
          userId: user.id
        }));
        return /*#__PURE__*/jsx(FontPane, {});
      case "user-area.teknisk-support":
        await prefetchQueryIfNeeded(queryClient, getStatusForProductQuery(productId));
        return /*#__PURE__*/jsx(Status, {});
      default:
        return /*#__PURE__*/jsx("div", {
          className: verticalPaddingCls,
          children: /*#__PURE__*/jsx(NotFound, {})
        });
    }
  })();
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx("div", {
      className: content,
      children: content$1
    }), /*#__PURE__*/jsx("div", {
      className: footer,
      children: /*#__PURE__*/jsx(BasicFooter, {})
    })]
  });
}

export { renderUserAreaPage };
//# sourceMappingURL=_render-page.js.map
